// src/components/TopDestinations.js

import React from 'react';
import destination1 from '../images/destination/destination1.jpg';
import destination2 from '../images/destination/destination25.jpg';
import destination15 from '../images/destination/3.jpg';
import destination16 from '../images/destination/4.jpg';

const destinations = [
  {
    id: 1,
    image: destination2,
    title: 'Italy',
    subtitle: 'Farm Experiences',
    tours: 18,
    fullWidth: true,
  },
  {
    id: 2,
    image: destination15,
    title: 'Moscow',
    subtitle: 'Shivar Feri',
    tours: 15,
  },
  {
    id: 3,
    image: destination16,
    title: 'Florida',
    subtitle: 'Rain Dance & DJ Music',
    tours: 32,
  },
  {
    id: 4,
    image: destination1,
    title: 'England',
    subtitle: 'Hurda Party',
    tours: 15,
    largeRight: true,
  },
];

const Topattraction = () => {
  return (
    <section className="trending pb-3 pt-0">
      <div className="container">
        <div className=" mb-6 w-5 mx-auto text-center">
          <h4 className="mb-1 theme1">Top Attractions</h4>
          <h2 className="mb-1">
            Explore <span className="theme">Top Attractions</span>
          </h2>
          <p>
           Explore the top attractions in Morachi Chincholi: peaceful green areas, calm ponds, and beautiful flowers.


          </p>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-7">
            <div className="row">
              {destinations.slice(0, 3).map((dest, index) => (
                <div
                  key={dest.id}
                  className={`${
                    index === 0 ? 'col-lg-12' : 'col-lg-6 col-md-6 col-sm-6'
                  } mb-4`}
                >
                  <div className="trend-item1">
                    <div className="trend-image position-relative rounded">
                      <img src={dest.image} alt={dest.title} className="img-fluid" />
                      <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                        <div className="trend-content-title">
                          <h5 className="mb-0">
                            <a href="/tour-grid" className="theme1">
                              {dest.title}
                            </a>
                          </h5>
                          <h3 className="mb-0 white">{dest.subtitle}</h3>
                        </div>
                        {/* <span className="white bg-theme p-1 px-2 rounded">{dest.tours} Tours</span> */}
                      </div>
                      <div className="color-overlay"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-5 mb-4">
            <div className="trend-item1">
              <div className="trend-image position-relative rounded">
                <img src={destinations[3].image} alt={destinations[3].title} className="img-fluid" />
                <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                  <div className="trend-content-title">
                    <h5 className="mb-0">
                      {/* <a href="/tour-grid" className="theme1">
                        {destinations[3].title}
                      </a> */}
                    </h5>
                    <h3 className="mb-0 white">{destinations[3].subtitle}</h3>
                  </div>
                  {/* <span className="white bg-theme p-1 px-2 rounded">{destinations[3].tours} Tours</span> */}
                </div>
                <div className="color-overlay"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Topattraction;
